import datehelper from './date'
import linq from 'linq'
function newbill(configs) {
    console.log('newbill', configs)
    const newrow = {}
    for (var i = 0; i < configs.length; i++) {
        if (configs[i].DataField === '') {
            continue
        }
        if (configs[i].Default !== undefined) {
            if (configs[i].Default === 'Today') {
                newrow[configs[i].DataField] = datehelper.datetimeFormat(new Date(), 'yyyy-MM-dd')
            } else if (configs[i].Default === 'Now') {
                newrow[configs[i].DataField] = datehelper.datetimeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss')
            } else {
                newrow[configs[i].DataField] = configs[i].Default
            }
        } else if (configs[i].DataField === 'ID') {
            newrow[configs[i].DataField] = 0
        } else if (configs[i].Type === 4) {
            newrow[configs[i].DataField] = 0
        } else {
            newrow[configs[i].DataField] = ''
        }
    }
    return newrow
}
function isWeixinBrowser() {
    const ua = navigator.userAgent.toLowerCase()
    const isWeixin = ua.indexOf('micromessenger') !== -1
    const isiOS = /iphone|ipad|ipod/.test(ua)
    const isAndroid = ua.indexOf('android') > -1

    return {
        isWeixin,
        isiOS,
        isAndroid
    }
}
function isArray(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]'
}
function copyArray(tarray, sarray) {
    for (var i = 0; i < sarray.length; i++) {
        var source = sarray[i]
        var object = {}
        if (typeof source === 'object') {
            copyObjectS(object, source)
            tarray.push(object)
        } else {
            copyArray(object, source)
            tarray.push(object)
        }
    }
}
function copyObjectS(tobj, sobj) {
    if (isArray(sobj)) {
        tobj = []
        for (var i = 0; i < sobj.length; i++) {
            tobj[i] = null
            copyObjectS(tobj[i], sobj[i])
        }
    } else if (typeof sobj === 'object') {
        for (var item in sobj) {
            if (sobj[item] == null) {
                tobj[item] = null
            } else if (isArray(sobj[item])) {
                tobj[item] = []
                for (let i = 0; i < sobj[item].length; i++) {
                    if (sobj[item][i] === null) {
                        tobj[item][i] = null
                    } else if (isArray(typeof sobj[item][i])) {
                        tobj[item][i] = []
                        copyArray(tobj[item][i], tobj[item][i])
                    } else if (typeof sobj[item][i] === 'object') {
                        tobj[item][i] = {}
                        copyObjectS(tobj[item][i], sobj[item][i])
                    } else {
                        tobj[item][i] = sobj[item][i]
                    }
                }
            } else if (typeof sobj[item] === 'object') {
                // eslint-disable-next-line no-prototype-builtins
                if (!tobj.hasOwnProperty(item)) {
                    tobj[item] = {}
                }
                copyObjectS(tobj[item], sobj[item])
            } else {
                tobj[item] = sobj[item]
            }
        }
    } else {
        tobj = sobj
    }
}
// 明细填充使用
const dofillitembyhdgrp2 = function(workitem, fillitem, normalfields, {
    fillgrp,
    tablekey,
    onfill,
    commongrp // 发起方的commomgrp
}) {
    const fields = linq.from(normalfields).where(x => (x.HDGrp2 & fillgrp) > 0).toArray()
    for (let i = 0; i < fields.length; i++) {
        var normalfield = fields[i]
        var datafield = normalfield.DataField
        var fetchfield = normalfield.FetchField ? normalfield.FetchField : null
        var grp = normalfield.HDGrp2
        if ((grp & fillgrp) > 0) {
            if (fetchfield) {
                if (fetchfield === '?FXK') {
                    workitem[datafield] = tablekey
                } else {
                    // eslint-disable-next-line no-prototype-builtins
                    if (fillitem.hasOwnProperty(fetchfield)) {
                        if (fillitem[fetchfield] === null) {
                            if ((commongrp & 512) > 0 || (normalfield.CommonGrp & 512) > 0) {
                                // 忽略NULL填充
                                continue
                            }
                        }
                        workitem[datafield] = fillitem[fetchfield]
                        if (typeof onfill === 'function') {
                            onfill(datafield)
                        }
                    }
                }
            } else {
                // eslint-disable-next-line no-prototype-builtins
                if (fillitem.hasOwnProperty(datafield)) {
                    if (fillitem[datafield] === null) {
                        if ((commongrp & 512) > 0 || (normalfield.CommonGrp & 512) > 0) {
                            continue
                        }
                    }
                    workitem[datafield] = fillitem[datafield]
                    if (typeof onfill === 'function') {
                        onfill(datafield)
                    }
                }
            }
        }
    }
    return workitem
}
export default {
    newbill,
    isWeixinBrowser,
    copyObjectS,
    isArray,
    copyArray,
    dofillitembyhdgrp2
}
